export default __webpack_public_path__ + "static/colorHpsp-976f492ec6cf6743a4ff8ef3c47d0fbf.png";